// extracted by mini-css-extract-plugin
module.exports = {"lenkeliste":"Lenkeliste_lenkeliste__RiAtg"};